import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, message, Spin, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import EventOverview from './EventOverview';
import FormSelector from './FormSelector';
import MagicLinksManager from './MagicLinksManager';
import EventAnalytics from './EventAnalytics';

export default function EventDetails() {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();
  const [event, setEvent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');

  useEffect(() => {
    if (eventId) {
      fetchEvent();
    }
  }, [eventId]);

  const fetchEvent = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/v1/feedback/events/${eventId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await res.json();
      setEvent(data);
    } catch (error) {
      message.error('Failed to fetch event');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!event) {
    return (
      <div style={{ padding: 24 }}>
        <p>Event not found</p>
      </div>
    );
  }

  const tabs = [
    {
      key: 'overview',
      label: 'Overview',
      children: <EventOverview event={event} />,
    },
    {
      key: 'form',
      label: 'Form',
      children: <FormSelector event={event} onUpdate={fetchEvent} />,
    },
    {
      key: 'magic-links',
      label: 'Magic Links',
      children: <MagicLinksManager eventId={event.id} />,
    },
    {
      key: 'analytics',
      label: 'Analytics',
      children: <EventAnalytics />,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/feedback/events')}
        >
          Back to Events
        </Button>
        <div>
          <h1 style={{ margin: 0 }}>{event.name}</h1>
          <p style={{ margin: 0, color: '#888' }}>{event.slug}</p>
        </div>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabs}
      />
    </div>
  );
}
